import React from 'react';

import styles from './EmailListInput.scss';
import SuccessIcon from './check.svg';
import ErrorIcon from './error-icon.svg';

class EmailListInput extends React.Component {
  constructor(props) {
    super(props);

    this.convertFieldValue = this.convertFieldValue.bind(this);
  }
  componentDidMount() {
    const { updateFieldValidity, value } = this.props;
    if (updateFieldValidity)
      updateFieldValidity(value, this.emailListInput.validity);
  }

  componentDidUpdate() {
    const { focusedField, name, readonly } = this.props;
    if (!readonly && this.props.focusedField === this.props.fieldName) {
      this.emailListInput.focus();
    }
  }

  convertFieldValue(emailStatus, value) {
    if (emailStatus && Object.keys(emailStatus).length) {
      return Object.keys(emailStatus).join('\n');
    }
    return value || '';
  }

  render() {
    const {
      name,
      value,
      autocomplete,
      readonly,
      handleChange,
      handleFocus,
      isFocused,
      emailStatus,
    } = this.props;
    const focusClass = isFocused && !readonly ? ' is-focused' : '';
    const convertedValue = this.convertFieldValue(emailStatus, value);
    const newLines = convertedValue.match(/\n/gi);
    const lines = newLines === null ? 1 : newLines.length + 1;
    const lineIndicators = [];
    if (readonly && emailStatus) {
      const emails = Object.keys(emailStatus);
      if (emails.length > 0) {
        for (let i = 0; i < lines; i++) {
          const status = emailStatus[emails[i]].type;
          lineIndicators.push(
            <div
              className={`EmailListInput__indicator EmailListInput__indicator--${status}`}
              key={`i-${i + 1}`}
            >
              {status === 'success' ? <SuccessIcon /> : <ErrorIcon />}
            </div>
          );
        }
      }
    } else {
      for (let i = 0; i < lines; i++) {
        lineIndicators.push(
          <div className="EmailListInput__indicator" key={`i-${i + 1}`}>
            {i + 1}
          </div>
        );
      }
    }
    return (
      <div className={`EmailListInput${focusClass}`}>
        <div className="EmailListInput__indicators">{lineIndicators}</div>
        <textarea
          ref={textarea => {
            this.emailListInput = textarea;
          }}
          id={`input-${name}`}
          name={name}
          className="EmailListInput__textarea"
          value={convertedValue}
          onChange={e => handleChange(e.target)}
          onFocus={e => handleFocus(e)}
          onBlur={e => handleFocus(e)}
          spellCheck={false}
          autoComplete={autocomplete}
          autoFocus={isFocused}
          readOnly={readonly}
        />
      </div>
    );
  }
}

export default EmailListInput;
